// extracted by mini-css-extract-plugin
export default {"networkHolder":"NetworkName_networkHolder__50G-e","network":"NetworkName_network__dXEET","networkName":"NetworkName_networkName__TqnDl"};